import React, { ButtonHTMLAttributes, forwardRef, ReactElement } from 'react';
import { cn } from '../../../shared/lib/utils';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  startIcon?: ReactElement;
  endIcon?: ReactElement;
  text: string;
  size?: 'default' | 'sm' | 'md' | 'lg';
  bg?: 'default' | 'black' | 'white';
  disabled?: boolean;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      className,
      startIcon,
      endIcon,
      text,
      size = 'default',
      bg = 'default',
      disabled,
      ...props
    },
    ref,
  ) => {

    const baseStyles = `
      text-[1rem]
      rounded-[40px] 
      flex items-center justify-between gap-4
      normal
      whitespace-nowrap
      transition-colors 
      focus-visible:outline-none 
      focus-visible:ring-2 
      focus-visible:ring-offset-2`;

    const sizes = {
      default: 'w-fit gap-4',
      sm: 'w-[190px]',
      md: 'w-[240px]',
      lg: 'w-[290px]',
    };

    const colors = {
      default: '',
      white: "bg-[var(--white-solid)]",
      black: "bg-[var(--black-solid)] text-white"
    }

    return (
      <button
        ref={ref}
        className={cn(
          baseStyles,
          sizes[size],
          colors[bg],
          className,
        )}
        disabled={disabled}
        {...props}
      >
        {startIcon && startIcon}
        {text}
        {endIcon && endIcon}
      </button>
    );
  },
);

Button.displayName = 'Button'; 